
import {
	Modal,
	Checkbox,
	DatePicker,
	Progress,
} from "antd";
import { ColumnsType } from "antd/lib/table";
import { MenuPage } from "components";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
import './style.scss'

export const AddStudentInCourseModal: React.FC<any> = ({ ...props }) => {
	const [usersWithAccess, setUsersWithAccess] = useState<any[]>([]);
	const [allUsersWithProgress, setAllUsersWithProgress] = useState<any[]>([]);
	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		setCourseStatus,
		currentCourseData,
	} = props;
	const handleRegister = (values: any) => {
		api
			.post(`/courses/${currentCourseData?.id}/users/add`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					form.resetFields();
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	const columns: ColumnsType<any> = [
		{
			title: "Nome",
			dataIndex: "name",
			key: "name",
			render: (_, record) => (
				<p style={{ margin: 0 }}>{record?.person?.name}</p>
			),
			onCell: () => {
				return {
					width: "12.5%",
				};
			},
		},
		{
			title: "E-mail",
			dataIndex: "email",
			key: "email",
			onCell: () => {
				return {
					width: "12.5%",
				};
			},
		},
		{
			title: "Data de nascimento",
			dataIndex: "birth_date",
			key: "birth_date",
			render: (text, record) => (
				<p style={{ margin: 0 }}>
					{record?.person?.birth_date ? record?.person?.birth_date : "-"}
				</p>
			),
			onCell: () => {
				return {
					width: "12.5%",
				};
			},
		},
		// {
		// 	title: "Status",
		// 	dataIndex: "status",
		// 	key: "status",
		// 	onCell: () => {
		// 		return {
		// 			width: "10",
		// 		};
		// 	},
		// },
		{
			title: "Progresso no curso",
			key: "",
			render: (_) => (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					{allUsersWithProgress.map((user) => user.user_id).includes(_.id) ? (
						<Progress
							percent={
								allUsersWithProgress.find(({ user_id }) => user_id === _.id)
									.progress
							}
							strokeWidth={8}
							showInfo={false}
						/>
					) : (
						"-"
					)}
				</div>
			),
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Acesso ao curso",
			key: "start_access",
			render: (_, record) => (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Checkbox
						checked={usersWithAccess.map((user) => user.user_id).includes(_.id)}
						onChange={(e) => {
							if (e.target.checked) {
								setUsersWithAccess((prevState) => {
									if (prevState.map((item) => item.user_id).includes(_.id)) {
										return prevState;
									}
									return [...prevState, { user_id: _.id }];
								});
								return;
							}
							setUsersWithAccess((prevState) =>
								prevState.filter((itens) => itens.user_id !== _.id)
							);
						}}
					/>
				</div>
			),
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Acesso até",
			key: "end_access",
			render: (_, record) => (
				<div style={{ width: "100%" }}>
					<DatePicker
						format={"DD/MM/YYYY"}
						placeholder={"Selecione uma data"}
						style={{ width: "90%" }}
						showToday={false}
						onChange={(_, date) => {
							setUsersWithAccess((prevState) => {
								const currentUser = prevState
									.map((item) => item.user_id)
									.indexOf(record.id);
								if (currentUser !== -1) {
									prevState[currentUser] = {
										...prevState[currentUser],
										expires_data: date,
									};
									return prevState;
								}
								return prevState;
							});
						}}
					/>
				</div>
			),
			onCell: () => {
				return {
					width: "20%",
				};
			},
		},
	];

	useEffect(() => {
		if (isOpen) {
			setUsersWithAccess([]);
			api.get(`/courses/${currentCourseData?.id}/students`).then((res) => {
				setUsersWithAccess(
					res.data.data.users.map((item: any) => {
						return { user_id: item.id };
					})
				);
			});
		}
	}, [isOpen, currentCourseData]);

	useEffect(() => {
		if (usersWithAccess.length && currentCourseData) {
			setAllUsersWithProgress([]);
			usersWithAccess.map(({ user_id }) => {
				api
					.get(`/courses/${currentCourseData.id}/users/${user_id}/progress`)
					.then((res) => {
						setAllUsersWithProgress((prevState) => [
							...prevState,
							{ user_id, progress: res.data.data },
						]);
					});
				return null;
			});
		}
	}, [usersWithAccess, currentCourseData, isOpen]);

	

	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.users;
	}

	return (
		<div>
		<Modal
			title={<h3 style={{ marginTop: 4, marginBottom: 4 }}>Alunos do curso "{currentCourseData?.title}"</h3>}
			open={isOpen}
			maskClosable={false}
			okText="Adicionar alunos"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = {
							users: usersWithAccess,
						};
						form.resetFields();
						handleRegister(allValues);
						setCurrentImgURL("");
						setCourseStatus(false);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
			}}
			className="modal-add-students"
		>

			<MenuPage 
				title=''
				subtitle="Adicione alunos ao curso" 
				tableColumns={columns} 
				sourceDataUrl={'/manager/users'}  
				getDataFromResponse={getTableDataFromResponse} 
				showAddButton={false}
				searchPlaceholder="Busque por nome"
				noPadding={true}
			/>
		</Modal>
		</div>
	);
};
